// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__3DxKb","label":"Loading_label__OeQNF","icon":"Loading_icon__mIswD"};